import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class MapMyIndiaService {

  constructor(private http: HttpClient) {}

  /**
   * Get MapMyIndia access token from TMS API
   */
  getToken(): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    // Use the TMS API endpoint instead of calling MapMyIndia directly
    const url = `${environment.baseUrl}/tms-tracking/map/token?provider=MAPMYINDIA`;

    return this.http.get(url, { headers });
  }

  /**
   * Store token in localStorage
   */
  saveToken(token: string): void {
    console.log(">>>>>saveToken>>>>", token);
    localStorage.setItem('mapmyindia_token', token);
  }

  /**
   * Get token from localStorage
   */
  getStoredToken(): string | null {
    return localStorage.getItem('mapmyindia_token');
  }

  /**
   * Clear token from localStorage
   */
  clearToken(): void {
    localStorage.removeItem('mapmyindia_token');
  }

  /**
   * Get token with automatic storage
   * This method fetches the token and automatically stores it
   */
  getAndStoreToken(): Observable<any> {
    return new Observable(observer => {
      this.getToken().subscribe({
        next: (response) => {
          if (response?.data?.token) {
            this.saveToken(response.data.token);
            observer.next(response.data.token);
          } else {
            observer.error('No token received from API');
          }
          observer.complete();
        },
        error: (error) => {
          observer.error(error);
        }
      });
    });
  }
}
